import { EVENT_ROLE, EVENT_ROLE_ORDER, EventRole, EventRoleFlags } from 'src/app/types/event-access.types';

type RolePredicate = (flags: Partial<EventRoleFlags>) => boolean;

/**
 * Cuándo un evento ofrece cada botón de entrada. "Reporte global" se oculta donde ya hay
 * Administrador: en los eventos de su productora el admin ya ve todo. En eventos de otra
 * productora (sin fuente admin) sí aparece.
 */
const ROLE_PREDICATES: Readonly<Record<EventRole, RolePredicate>> = {
  [EVENT_ROLE.SELLER]: flags => !!flags.canSell,
  [EVENT_ROLE.SALES_MANAGER]: flags => !!flags.isBossEvent,
  [EVENT_ROLE.ADMINISTRATOR]: flags => !!flags.isAdminEvent,
  [EVENT_ROLE.GLOBAL_REPORT]: flags => !!flags.canViewGlobalReport && !flags.isAdminEvent,
  [EVENT_ROLE.SCANNER]: flags => !!flags.isAdminEvent,
};

/** Roles de entrada de un evento, en el orden de los botones. Sin roles, el evento no se lista. */
export function buildEventRoles(flags: Partial<EventRoleFlags>): EventRole[] {
  return EVENT_ROLE_ORDER.filter(role => ROLE_PREDICATES[role](flags));
}
